import { Box, Button, Container, Typography } from "@mui/material";
import { images } from "../../assets";
import { useLocation } from "react-router-dom";
import en from "../../locales/en.json";
import es from "../../locales/es.json";
import it from "../../locales/it.json";

const locales = { en, es, it };
const UnVarified = () => {
  const location = useLocation();
  const language = location?.state?.language || "en";
  const url = location?.state?.url;
  const t = locales[language];

  return (
    <>
      <Box display="flex" justifyContent="center" sx={{ pt: { xs: 4, md: 6 } }}>
        <img
          src={images.certageLogo}
          alt="Logo"
          style={{
            width: "min(70vw, 300px)",
            height: "auto",
            maxHeight: "140px",
          }}
        />
      </Box>

      <Container>
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          gap={2}
          sx={{
            height: { xs: "40vh", md: "60vh" },
            width: { xs: "90%", md: "40%" },
            mx: "auto",
          }}
        >
          <img
            src={images.certageError}
            alt="Logo"
            style={{
              width: "min(70vw, 300px)",
              height: "auto",
              maxHeight: "140px",
            }}
          />
          <Typography textAlign="center" fontSize={16} color="primary.text">
            {t.unverified.message}
          </Typography>
        </Box>
        <Box
          display={"flex"}
          justifyContent={"center"}
          sx={{ width: { xs: "100%", md: "70%" } }}
          mx="auto"
        >
          <Button
            fullWidth={false}
            onClick={() => {
              window.location.href = url;
            }}
            sx={{
              backgroundColor: "#1818de",
              px: { xs: 0, sm: 5 },
              py: 1.5,
              width: "70%",
              mx: "auto",
              borderRadius: "12px",
              mb: 2,
              fontSize: { xs: 16, sm: 24 },
              fontWeight: 600,
              color: "#fff",
              "&:hover": { backgroundColor: "#1515b0" },
            }}
          >
            {t.unverified.button}
          </Button>
        </Box>
      </Container>
    </>
  );
};

export default UnVarified;
